import { render, staticRenderFns } from "./LaoExtra.vue?vue&type=template&id=946e6634&"
import script from "./LaoExtra.vue?vue&type=script&lang=js&"
export * from "./LaoExtra.vue?vue&type=script&lang=js&"
import style0 from "./LaoExtra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports